// src/pages/CourseTime/components/slides/layouts/SectionIntroSlide.comp.jsx
import React from 'react';
import * as S from '../../../styles';
import SlideTitleSpoken from '../common/SlideTitleSpoken.comp';

// Layout: SECTION_INTRO
// Intro shown before each DQ-competency section of an assessment.
// SlideContent carries the section description (a plain string).
const SectionIntroSlide = ({ slide, renderSpokenText, skipTitleSpeech }) => (
  <S.AssessmentIntroContainer>
    <S.AssessmentIntroContent style={{ textAlign: 'center', maxWidth: 760, margin: '0 auto' }}>
      <S.AssessmentIntroTitle>
        <SlideTitleSpoken slide={slide} skipTitleSpeech={skipTitleSpeech} renderSpokenText={renderSpokenText} />
      </S.AssessmentIntroTitle>
      {typeof slide.SlideContent === 'string' && slide.SlideContent && (
        <S.SlideDescription style={{ textAlign: 'center', marginTop: 16 }}>
          {renderSpokenText('content_0', slide.SlideContent)}
        </S.SlideDescription>
      )}
    </S.AssessmentIntroContent>
  </S.AssessmentIntroContainer>
);

export default SectionIntroSlide;
